
(function(){
'use strict';
const isolatedParams=new URLSearchParams(location.search);
if(isolatedParams.get('vv_product')&&['harfli','stripe'].includes(isolatedParams.get('vv_mode')))return;
if(window.VV_STICKER_LIB)return;window.VV_STICKER_LIB=true;
const urls=["https://cdn.shopify.com/s/files/1/0732/6515/2155/files/velvoria-sticker-atlas-01.png?v=1791911482","https://cdn.shopify.com/s/files/1/0732/6515/2155/files/velvoria-sticker-atlas-02.png?v=1791911505","https://cdn.shopify.com/s/files/1/0732/6515/2155/files/velvoria-sticker-atlas-03.png?v=1791911512","https://cdn.shopify.com/s/files/1/0732/6515/2155/files/velvoria-sticker-atlas-04.png?v=1791911520","https://cdn.shopify.com/s/files/1/0732/6515/2155/files/velvoria-sticker-atlas-05.png?v=1791911530","https://cdn.shopify.com/s/files/1/0732/6515/2155/files/velvoria-sticker-atlas-06.png?v=1791911541","https://cdn.shopify.com/s/files/1/0732/6515/2155/files/velvoria-sticker-atlas-07.png?v=1791911553","https://cdn.shopify.com/s/files/1/0732/6515/2155/files/velvoria-sticker-atlas-08.png?v=1791911560","https://cdn.shopify.com/s/files/1/0732/6515/2155/files/velvoria-sticker-atlas-09.png?v=1791911568"],n=418,colCount=7,tile=240,per=49,W=600,H=900;
const names=['Önerilen','Hayvanlar','Objeler','Çiçekler','Kurdeleler','Kalpler & Yıldızlar','Yazılar & Etiketler','Retro','Tüm Stickerlar'];
const at=urls.map(u=>{const i=new Image();i.crossOrigin='anonymous';i.src=u;return i});
function item(i){const pos=i%per;return {img:at[Math.floor(i/per)],url:urls[Math.floor(i/per)],x:pos%7,y:Math.floor(pos/7)}}
function sprite(el,i){const v=item(i);el.style.backgroundImage='url("'+v.url+'")';el.style.backgroundPosition=(v.x*100/6)+'% '+(v.y*100/6)+'%';}
function category(i){
 if(i>=10&&i<=14||i>=160&&i<=171||i>=215&&i<=224)return 1;
 if(i>=20&&i<=24||i>=30&&i<=39||i>=60&&i<=64||i>=179&&i<=190&&i%2===0)return 3;
 if(i===3||i===23||i>=148&&i<=159&&i%3===0)return 4;
 if(i===0||i===1||i===2||i===7||i===8||i>=394&&i%6===0)return 5;
 if(i>=225&&i<=236||i>=25&&i<=29||i>=375&&i<=387)return 6;
 if(i>=289&&i<=361||i>=362&&i<=374||i>=40&&i<=59)return 7;
 if(i>=237&&i<=288)return [1,3,4,5,6,2,2][i%7];
 if(i>=65&&i<=134)return [1,3,4,5,2,2,2,2][i%8];
 return 2;
}
document.querySelectorAll('.vv-studio-badge').forEach(a=>{
 a.addEventListener('click',e=>{
  e.preventDefault();
  const u=new URL(a.href,location.origin);
  const form=document.querySelector('form[action*="/cart/add"]');
  const id=form?.querySelector('input[name="id"],select[name="id"]')?.value||new URL(location.href).searchParams.get('variant');
  if(id)u.searchParams.set('vv_variant',id);
  let info={media:[],variants:[]};
  try{info=JSON.parse(a.nextElementSibling?.classList.contains('vv-studio-product-media')?a.nextElementSibling.textContent:'{}')}catch(_){}
  const v=(info.variants||[]).find(x=>String(x.id)===String(id));
  const letter=a.dataset.vvMode==='harfli'?String(v?.option1||v?.options?.[0]||'').trim():'';
  const arr=info.media||[];
  function tagged(name){
   return arr.find(x=>{const alt=(x.alt||'').trim();return letter?alt.endsWith(letter+' - '+name):alt.endsWith(' - '+name)||alt.endsWith('-'+name)});
  }
  const front=tagged('Ana')||arr.find(x=>/(Ana|Arka)/i.test(x.alt||''))||arr[0];
  const combined=tagged('Yan')||tagged('Birleşik')||arr.find(x=>/(Yan|Birleşik|Birl)/i.test(x.alt||''))||arr[1]||front;
  if(front?.url){u.searchParams.set('vv_front',front.url);u.searchParams.set('vv_image',front.url)}
  if(combined?.url)u.searchParams.set('vv_combined',combined.url);
  if(letter)u.searchParams.set('vv_letter',letter);
  const title=info.title||document.querySelector('h1')?.textContent?.trim()||'';
  if(title)u.searchParams.set('vv_title',title.slice(0,120));
  const model=title.match(/iPhone\s+1[2-8](?:\s+(?:Pro Max|Pro|Plus|Air))?/i);
  if(model)u.searchParams.set('vv_model',model[0].replace(/\s+/g,' ').replace(/^iphone/i,'iPhone'));
  if(v?.option2)u.searchParams.set('vv_type',v.option2);
  // Plain pre-product-mockup Art Studio; keep the product/variant/model context only.
  u.searchParams.set('vv_mockup','off');
  for(const key of ['vv_front','vv_combined','vv_image','vv_studio_front_media_v2'])u.searchParams.delete(key);
  location.assign(u.href);
 });
});
const root=document.getElementById('velvoria-v4');if(!root)return;
const vvMode=new URLSearchParams(location.search);
if(!vvMode.get('vv_product')||!['harfli','stripe'].includes(vvMode.get('vv_mode')))return;
const editor=root.querySelector('.editor'),stage=root.querySelector('.stage'),cv=root.querySelector('#v4-canvas');
if(!editor||!stage||!cv)return;
const data=[],color={},query=new URLSearchParams(location.search);
let chosen=-1,tab=0,rev=0,reference=[100,100,100],recommended=[];
function paint(ctx){for(const s of data){const a=item(s.id);if(!a.img.complete||!a.img.naturalWidth)continue;ctx.save();ctx.translate(s.x,s.y);ctx.rotate(s.rot*Math.PI/180);ctx.drawImage(a.img,a.x*tile,a.y*tile,tile,tile,-s.size/2,-s.size/2,s.size,s.size);ctx.restore()}}
function paintMasked(target){
 const image=vvGetCompleteCaseMask();
 if(!image)return;
 const maskedLayer=document.createElement('canvas');maskedLayer.width=target.canvas.width;maskedLayer.height=target.canvas.height;
 const p=maskedLayer.getContext('2d');
 p.setTransform(target.getTransform());
 paint(p);
 p.globalCompositeOperation='destination-in';
 p.drawImage(image,0,0,W,H);
 p.globalCompositeOperation='source-over';
 target.save();target.setTransform(1,0,0,1,0,0);target.drawImage(maskedLayer,0,0);target.restore();
}
window.VelvoriaStickers={get revision(){return rev},paint,paintPreview:paintMasked,paintPrint:paintMasked,selected:data};
const section=document.createElement('section');section.className='vv-lib';section.innerHTML='<h3>Sticker ekle</h3><div role="tablist" class="vv-tabs"></div><div class="vv-items"></div><div class="vv-tools"><button type="button" data-a="minus">Küçült −</button><button type="button" data-a="plus">Büyüt ＋</button><button type="button" data-a="rotate">Döndür ↻</button><button type="button" data-a="duplicate">Çoğalt</button><button type="button" data-a="delete">Sil</button></div><p>Stickerları kılıf üzerinde taşıyabilir, büyütebilir ve döndürebilirsin.</p>';editor.append(section);
const tabs=section.querySelector('.vv-tabs'),grid=section.querySelector('.vv-items'),layer=document.createElement('div');layer.className='vv-overlay';stage.append(layer);
const combinedStickerCanvas=document.createElement('canvas');
combinedStickerCanvas.className='vv-combined-sticker-canvas';
combinedStickerCanvas.width=W;combinedStickerCanvas.height=H;
stage.append(combinedStickerCanvas);
function syncLayer(){
 const a=cv.getBoundingClientRect(),b=stage.getBoundingClientRect();
 for(const el of [layer,combinedStickerCanvas]){
  el.style.left=a.left-b.left+'px';
  el.style.top=a.top-b.top+'px';
  el.style.width=a.width+'px';
  el.style.height=a.height+'px';
 }
}
new ResizeObserver(syncLayer).observe(cv);syncLayer();
let maskIdentity='';
const vvCaseSurfaceCache=new WeakMap();
function vvGetCompleteCaseMask(){
 const photo=root.vvStickerProductImages?.front;
 const fallback=root.vvStickerMaskSources?.back;
 const key=photo?.naturalWidth?photo:fallback;
 if(!key?.naturalWidth)return null;
 const cached=vvCaseSurfaceCache.get(key);
 if(cached)return cached;
 const mask=document.createElement('canvas');
 mask.width=W;mask.height=H;
 const m=mask.getContext('2d');
 const picture=document.createElement('canvas');
 picture.width=W;picture.height=H;
 const pc=picture.getContext('2d',{willReadFrequently:true});
 pc.drawImage(key,0,0,W,H);
 let rgba=null;
 try{rgba=pc.getImageData(0,0,W,H).data}catch(_){rgba=null}
 const difference=(x,y,ref)=>{
  if(!rgba)return 0;
  const k=(y*W+x)*4;
  return Math.abs(rgba[k]-ref[0])+Math.abs(rgba[k+1]-ref[1])+Math.abs(rgba[k+2]-ref[2]);
 };
 m.fillStyle='#fff';
 // Match the actual case silhouette, not the alpha of the ink/PSD texture.
 // Sticker print surface starts below the camera island (where the solid back begins).
 for(let y=307;y<=789;y++){
  const refPos=(y*W+16)*4;
  const bg=rgba?[rgba[refPos],rgba[refPos+1],rgba[refPos+2]]:[255,255,255];
  const centerDelta=difference(300,y,bg);
  let left=140,right=460,detected=false;
  if(photo?.naturalWidth&&centerDelta>25){
   let xLeft=-1,xRight=-1;
   for(let x=129;x<=190;x++){
    if(difference(x,y,bg)>38){xLeft=x;break}
   }
   for(let x=471;x>=411;x--){
    if(difference(x,y,bg)>38){xRight=x;break}
   }
   if(xLeft>0&&xRight>0&&xRight-xLeft>=275&&xRight-xLeft<=346){
    left=Math.max(138,Math.min(158,xLeft+1));
    right=Math.min(462,Math.max(442,xRight-1));
    detected=true;
   }
  }
  if(y>755&&!detected){
   const r=34,dy=Math.min(r,y-755),inset=r-Math.sqrt(Math.max(0,r*r-dy*dy));
   left+=inset;right-=inset;
  }
  if(right>left)m.fillRect(Math.floor(left),y,Math.ceil(right-left),1);
 }
 vvCaseSurfaceCache.set(key,mask);
 return mask;
}
function updateCaseSurfaceMask(){
 const body=vvGetCompleteCaseMask();
 if(!body)return;
 const combined=!!root.querySelector('[data-v4-view="combined"].active');
 const source=root.vvStickerProductImages?.front||root.vvStickerMaskSources?.back;
 const identity=[source?.src||'',combined].join('|');
 if(identity===maskIdentity)return;
 const bitmap=document.createElement('canvas');bitmap.width=W;bitmap.height=H;
 const g=bitmap.getContext('2d');
 if(combined){
  g.drawImage(body,140,114,320,675,142.5,115,315,664);
 }else{
  g.drawImage(body,0,0,W,H);
 }
 const maskUrl='url("'+bitmap.toDataURL('image/png')+'")';
 layer.style.webkitMaskImage=maskUrl;layer.style.maskImage=maskUrl;
 layer.style.webkitMaskSize='100% 100%';layer.style.maskSize='100% 100%';
 layer.style.webkitMaskRepeat='no-repeat';layer.style.maskRepeat='no-repeat';
 layer.style.webkitMaskMode='alpha';layer.style.maskMode='alpha';
 maskIdentity=identity;
}
const stickerProjectionSource=document.createElement('canvas');
stickerProjectionSource.width=W;stickerProjectionSource.height=H;
const stickerProjectionContext=stickerProjectionSource.getContext('2d');
const stickerProjectionPart=document.createElement('canvas');
let vvSidePhotoCache=null;
function vvGetSidePhotoGeometry(){
 const photo=root.vvStickerProductImages?.combined;
 if(vvSidePhotoCache?.photo===photo)return vvSidePhotoCache;
 const result={photo,leftInner:115,rightInner:491,mask:null,maskLeft:false,maskRight:false};
 if(!photo?.naturalWidth){vvSidePhotoCache=result;return result}
 try{
  const buffer=document.createElement('canvas');buffer.width=W;buffer.height=H;
  const bctx=buffer.getContext('2d',{willReadFrequently:true});
  bctx.drawImage(photo,0,0,W,H);
  const raw=bctx.getImageData(0,0,W,H).data;
  const bgIndex=y=>(y*W+20)*4;
  function different(x,y,threshold){
   const k=(y*W+x)*4,j=bgIndex(y);
   return Math.abs(raw[k]-raw[j])+Math.abs(raw[k+1]-raw[j+1])+Math.abs(raw[k+2]-raw[j+2])>threshold;
  }
  const left=[],right=[];
  for(let y=350;y<=730;y+=30){
   let a=null,b=null;
   for(let x=58;x<=129;x++){
    if(different(x,y,75)&&different(Math.max(57,x-1),y,55))a=x;
   }
   for(let x=474;x<=537;x++){
    if(different(x,y,75)&&different(Math.min(538,x+1),y,55)){b=x;break}
   }
   if(a!==null)left.push(a);
   if(b!==null)right.push(b);
  }
  const median=arr=>{const sorted=[...arr].sort((a,b)=>a-b);return sorted[Math.floor(sorted.length/2)]};
  if(left.length>=6)result.leftInner=Math.min(124,Math.max(99,median(left)));
  if(right.length>=6)result.rightInner=Math.min(507,Math.max(480,median(right)));
  result.maskLeft=left.length>=6;
  result.maskRight=right.length>=6;
  const canvas=document.createElement('canvas');canvas.width=W;canvas.height=H;
  const cx=canvas.getContext('2d');
  const mask=cx.createImageData(W,H);
  for(let y=115;y<781;y++){
   for(let x=56;x<=544;x++){
    if(x>130&&x<470)continue;
    const i=(y*W+x)*4;
    if(different(x,y,49)){
     mask.data[i]=255;mask.data[i+1]=255;mask.data[i+2]=255;mask.data[i+3]=255;
    }
   }
  }
  cx.putImageData(mask,0,0);
  result.mask=canvas;
 }catch(err){
  result.mask=null;result.maskLeft=false;result.maskRight=false;
 }
 vvSidePhotoCache=result;
 return result;
}
function drawCombinedStickerProjection(){
 const target=combinedStickerCanvas.getContext('2d');
 target.clearRect(0,0,W,H);
 if(!data.length)return;
 const body=vvGetCompleteCaseMask();
 if(!body)return;
 stickerProjectionContext.clearRect(0,0,W,H);
 paint(stickerProjectionContext);
 if(!root.querySelector('[data-v4-view="combined"].active')){
   // On both Safari and desktop all visible stickers are one masked canvas:
   // never depend on HTML element mask clipping for sticker pixels.
   const active=data[chosen];
   if(active){
     stickerProjectionContext.save();
     stickerProjectionContext.translate(active.x,active.y);
     stickerProjectionContext.rotate(active.rot*Math.PI/180);
     stickerProjectionContext.lineWidth=1.8;
     stickerProjectionContext.setLineDash([5,4]);
     stickerProjectionContext.strokeStyle='#2b211d';
     stickerProjectionContext.strokeRect(-active.size/2,-active.size/2,active.size,active.size);
     stickerProjectionContext.restore();
   }
   stickerProjectionPart.width=W;stickerProjectionPart.height=H;
   const temp=stickerProjectionPart.getContext('2d');
   temp.clearRect(0,0,W,H);
   temp.drawImage(stickerProjectionSource,0,0,W,H);
   temp.globalCompositeOperation='destination-in';
   temp.drawImage(body,0,0,W,H);
   temp.globalCompositeOperation='source-over';
   target.drawImage(stickerProjectionPart,0,0);
   return;
 }
 const sources=root.vvStickerMaskSources;
 const drawBack=()=>{
  stickerProjectionPart.width=630;stickerProjectionPart.height=1328;
  const ctx=stickerProjectionPart.getContext('2d');
  ctx.clearRect(0,0,630,1328);
  ctx.drawImage(stickerProjectionSource,140,114,320,674.5,0,0,630,1328);
  ctx.globalCompositeOperation='destination-in';
  ctx.drawImage(body,140,114,320,674.5,0,0,630,1328);
  ctx.globalCompositeOperation='source-over';
  target.drawImage(stickerProjectionPart,142.5,115,315,664);
 };
 drawBack();
 const geometry=vvGetSidePhotoGeometry();
 const stripWidth=22;
 const drawSide=(name,srcX,x,flip)=>{
  const w=44,h=1328;
  stickerProjectionPart.width=w;stickerProjectionPart.height=h;
  const ctx=stickerProjectionPart.getContext('2d');
  ctx.clearRect(0,0,w,h);
  ctx.save();
  if(flip){ctx.translate(w,0);ctx.scale(-1,1)}
  ctx.drawImage(stickerProjectionSource,srcX,114,22,675,0,0,w,h);
  ctx.restore();
  ctx.globalCompositeOperation='destination-in';
  const usePhotoMask=geometry.mask&&(name==='leftMask'?geometry.maskLeft:geometry.maskRight);
  if(usePhotoMask){
   ctx.drawImage(geometry.mask,x,115,stripWidth,664,0,0,w,h);
  }else{
   const sideMask=sources?.[name];
   if(sideMask?.naturalWidth){
    const fullX=name==='leftMask'?56.5:469.5;
    const cropX=Math.max(0,(x-fullX)/74*sideMask.naturalWidth);
    ctx.drawImage(sideMask,cropX,0,stripWidth/74*sideMask.naturalWidth,sideMask.naturalHeight,0,0,w,h);
   }else{ctx.fillStyle='#fff';ctx.fillRect(0,0,w,h)}
  }
  ctx.globalCompositeOperation='source-over';
  target.drawImage(stickerProjectionPart,x,115,stripWidth,664);
 };
 // Separated product photos have a real empty gutter. These bands are
 // anchored INSIDE their photographed case, not at the 74px layout boxes.
 const leftEdge=Math.min(124,Math.max(99,geometry.leftInner));
 const rightEdge=Math.max(480,Math.min(507,geometry.rightInner));
 drawSide('leftMask',118,leftEdge-stripWidth,false);
 drawSide('rightMask',460,rightEdge,false);
}
root.addEventListener('vv:case-masks-ready',()=>{
 maskIdentity='';updateCaseSurfaceMask();drawCombinedStickerProjection();
});
root.addEventListener('vv:product-preview-ready',()=>{
 maskIdentity='';updateCaseSurfaceMask();drawCombinedStickerProjection();
});
function locked(){return !root.querySelector('#v7-unlock')?.disabled}
function change(){rev++;const b=root.querySelector('#v14-order');if(b)b.disabled=true;const s=root.querySelector('#v14-order-status');if(s)s.textContent='Sticker değişti. Tasarımı yeniden kilitleyip siparişe hazırla.';renderObjects()}
function renderObjects(){
 updateCaseSurfaceMask();
 layer.replaceChildren();
 const combined=root.querySelector('[data-v4-view="combined"].active')!==null;
 layer.dataset.combined=combined?'true':'false';
 data.forEach((s,k)=>{const el=document.createElement('div');el.className='vv-object';sprite(el,s.id);el.setAttribute('role','button');el.setAttribute('tabindex','0');el.setAttribute('aria-selected',String(chosen===k));
 const xx=combined?142.5+(s.x-140)*315/320:s.x,yy=combined?115+(s.y-114)*664/674.5:s.y,ss=combined?s.size*315/320:s.size;
 el.style.left=xx/W*100+'%';el.style.top=yy/H*100+'%';el.style.width=ss/W*100+'%';el.style.aspectRatio='1';el.style.transform='translate(-50%,-50%) rotate('+s.rot+'deg)';
 el.onpointerdown=e=>{if(locked())return;e.preventDefault();e.stopPropagation();chosen=k;renderObjects();const startX=e.clientX,startY=e.clientY,ox=s.x,oy=s.y;
 const move=ev=>{s.x=Math.max(120,Math.min(480,ox+(ev.clientX-startX)*W/layer.clientWidth));s.y=Math.max(125,Math.min(805,oy+(ev.clientY-startY)*H/layer.clientHeight));change()};
 const end=()=>{window.removeEventListener('pointermove',move);window.removeEventListener('pointerup',end);window.removeEventListener('pointercancel',end)};
 window.addEventListener('pointermove',move);window.addEventListener('pointerup',end,{once:true});window.addEventListener('pointercancel',end,{once:true});
 };layer.append(el)});
 drawCombinedStickerProjection();
}
function add(i){if(locked())return alert('Önce Yeniden Düzenle butonuna bas.');data.push({id:i,x:300,y:470,size:110,rot:0});chosen=data.length-1;change()}
function cards(){grid.textContent='';const ids=tab===0?recommended:tab===8?Array.from({length:n},(_,i)=>i):Array.from({length:n},(_,i)=>i).filter(i=>category(i)===tab);
 const f=document.createDocumentFragment();for(const i of ids){const b=document.createElement('button');b.type='button';b.title='Sticker '+(i+1);b.setAttribute('aria-label','Sticker '+(i+1)+' ekle');const s=document.createElement('span');s.className='vv-sprite';sprite(s,i);b.append(s);b.onclick=()=>add(i);f.append(b)}grid.append(f)}
names.forEach((t,i)=>{const b=document.createElement('button');b.type='button';b.textContent=t;b.setAttribute('role','tab');b.setAttribute('aria-selected',String(i===0));b.onclick=()=>{tab=i;tabs.querySelectorAll('button').forEach((x,k)=>x.setAttribute('aria-selected',String(k===i)));cards()};tabs.append(b)});
function rank(){
 const ids=Array.from({length:n},(_,i)=>i).filter(i=>color[i]);
 ids.sort((a,b)=>{const dist=v=>color[v].reduce((s,x,k)=>s+(x-reference[k])**2,0);return dist(a)-dist(b)});
 const result=[],count={};for(const i of ids){const c=category(i);if((count[c]||0)>=5)continue;result.push(i);count[c]=(count[c]||0)+1;if(result.length===24)break}
 let seed=0;for(const x of(query.get('vv_product')||'velvoria'))seed=(seed*31+x.charCodeAt(0))|0;
 for(let j=0;result.length<24&&j<n;j++){const x=Math.abs(seed+j*37)%n;if(!result.includes(x))result.push(x)}
 recommended=result;if(tab===0)cards();
}
at.forEach((im,page)=>{const run=()=>{try{const c=document.createElement('canvas');c.width=12;c.height=12;const ctx=c.getContext('2d',{willReadFrequently:true});for(let v=0;v<49;v++){const i=page*49+v;if(i>=n)break;ctx.clearRect(0,0,12,12);ctx.drawImage(im,v%7*tile,Math.floor(v/7)*tile,tile,tile,0,0,12,12);const d=ctx.getImageData(0,0,12,12).data;let rgb=[0,0,0],ct=0;for(let a=0;a<d.length;a+=4){if(d[a+3]<130||d[a]>220&&d[a+1]>220&&d[a+2]>220)continue;for(let k=0;k<3;k++)rgb[k]+=d[a+k];ct++}if(ct)color[i]=rgb.map(v=>v/ct)}}catch(_){}rank()};if(im.complete&&im.naturalWidth)run();else im.addEventListener('load',run,{once:true})});
rank();
section.querySelector('.vv-tools').onclick=e=>{const action=e.target.closest('[data-a]')?.dataset.a;if(!action||chosen<0||locked())return;const s=data[chosen];
 if(action==='delete'){data.splice(chosen,1);chosen=Math.min(chosen,data.length-1)}
 if(action==='duplicate'){data.push({...s,x:s.x+25,y:s.y+25});chosen=data.length-1}
 if(action==='minus')s.size=Math.max(28,s.size-16);
 if(action==='plus')s.size=Math.min(260,s.size+16);
 if(action==='rotate')s.rot=(s.rot+15)%360;
 change()};
root.querySelectorAll('[data-v4-view]').forEach(b=>b.addEventListener('click',()=>requestAnimationFrame(renderObjects)));
at.forEach(stickerImage=>stickerImage.addEventListener('load',drawCombinedStickerProjection));
const prod=query.get('vv_product'),mode=query.get('vv_mode');
if(prod&&['harfli','stripe'].includes(mode)&&query.get('vv_mockup')!=='off'){
  const status=root.querySelector('#v4-state');
  const frontURL=query.get('vv_front')||query.get('vv_image');
  const combinedURL=query.get('vv_combined')||frontURL;
  const showError=message=>{if(status)status.textContent=message};
  const normalize=url=>{try{return new URL(url,location.origin).href}catch(_){return ''}};
  const useImages=(front,combined,model,letter)=>{
    if(typeof window.VVStudioProductPreview!=='function')throw new Error('Önizleme motoru yüklenemedi.');
    return window.VVStudioProductPreview(front,combined,model,letter);
  };
  const fromShopify=async()=>{
    if(!/^[a-z0-9][a-z0-9-]{0,200}$/.test(prod))throw new Error('Ürün kodu geçersiz.');
    const res=await fetch('/products/'+encodeURIComponent(prod)+'.js',{credentials:'same-origin',cache:'no-store'});
    if(!res.ok)throw new Error('Ürün verileri alınamadı ('+res.status+').');
    const p=await res.json();
    const variantId=query.get('vv_variant');
    const variant=(p.variants||[]).find(v=>String(v.id)===String(variantId))||p.variants?.[0];
    const letter=mode==='harfli'?String(query.get('vv_letter')||variant?.option1||variant?.options?.[0]||'').trim():'';
    const media=(p.media||[]).filter(m=>!m.media_type||m.media_type==='image').map(m=>({
      alt:m.alt||m.preview_image?.alt||'',
      url:m.src||m.preview_image?.src||m.preview_image?.url||''
    })).filter(m=>m.url);
    const images=(p.images||[]).map(m=>typeof m==='string'?{alt:'',url:m}:{alt:m.alt||'',url:m.src||m.url||''}).filter(m=>m.url);
    const all=media.length?media:images;
    const byLabel=(label)=>all.find(m=>{
      const alt=String(m.alt||'').trim();
      return letter?alt.endsWith(letter+' - '+label):alt.endsWith(' - '+label)||alt.endsWith(' - '+label.toLowerCase());
    });
    let front=byLabel('Ana')||all.find(m=>/(Ana|Arka)/i.test(m.alt||''))||null;
    if(letter&&!front){
      const variantImage=variant?.featured_image?.src||variant?.featured_image?.url;
      if(variantImage){
        front=all.find(m=>normalize(m.url).split('?')[0]===normalize(variantImage).split('?')[0])||{url:variantImage};
      }
    }
    front=front||all[0];
    const frontIndex=all.findIndex(m=>normalize(m.url).split('?')[0]===normalize(front?.url).split('?')[0]);
    const combined=byLabel('Yan')||byLabel('Birleşik')||byLabel('Birl')||(
      frontIndex>=0?all[frontIndex+1]:null
    )||front;
    if(!front?.url)throw new Error('Üründe ana mockup görseli bulunamadı.');
    const model=query.get('vv_model')||(p.title||'').match(/iPhone\s+1[2-8](?:\s+(?:Pro Max|Pro|Plus|Air))?/i)?.[0]||'';
    await useImages(front.url,combined.url,model,letter);
    showError('Seçilen '+(letter?letter+' harfli ':'')+'ürünün mockup görselleri yüklendi.');
    return true;
  };
  (async()=>{
    showError('Seçilen ürünün gerçek mockup görselleri yükleniyor…');
    try{
      if(!frontURL)throw new Error('Ürün bağlantısında görsel yok.');
      await useImages(frontURL,combinedURL,query.get('vv_model'),query.get('vv_letter'));
      return;
    }catch(err){
      try{await fromShopify();return}
      catch(err2){showError('Ürün mockupı açılamadı: '+err2.message+' Lütfen ürün sayfasından yeniden Özelleştir ile gir.')}
    }
  })();
}
if(prod&&['harfli','stripe'].includes(mode)){
 const banner=document.createElement('div');banner.className='vv-product-context';
 const head=document.createElement('strong');head.textContent=(mode==='stripe'?'Stripe':'Harfli')+' · '+(query.get('vv_title')||prod);banner.append(head);
 const imageURL=query.get('vv_image');if(imageURL){try{const u=new URL(imageURL);if(u.hostname==='cdn.shopify.com'){const pic=document.createElement('img');pic.src=u.href;pic.alt='Seçili ürün referansı';banner.append(pic);pic.crossOrigin='anonymous';pic.onload=()=>{try{const c=document.createElement('canvas');c.width=32;c.height=32;const ctx=c.getContext('2d');ctx.drawImage(pic,0,0,32,32);const d=ctx.getImageData(5,4,22,24).data;let t=[0,0,0],k=0;for(let j=0;j<d.length;j+=4){if(d[j]>235&&d[j+1]>235&&d[j+2]>235)continue;t=t.map((v,x)=>v+d[j+x]);k++}if(k){reference=t.map(x=>x/k);rank()}}catch(_){}}}}catch(_){}}
 const note=document.createElement('p');note.textContent='Bu üründe 1252 × 2220 baskı tabanı henüz eşleştirilmedi. Tasarım önizlemesi test aşamasındadır; yanlış üretimi önlemek için sipariş kapalı.';banner.append(note);editor.prepend(banner);
 const variant=query.get('vv_variant'),hid=root.querySelector('#v17-variant');if(variant&&hid)hid.value=variant;
 for(const id of ['v14-prepare','v14-order']){const b=root.querySelector('#'+id);if(b)b.addEventListener('click',e=>{e.preventDefault();e.stopImmediatePropagation();alert('Baskı tabanı doğrulanmadan sipariş oluşturulamaz.');},true)}
}
})();

